import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tripDuration'
})
export class TripDurationPipe implements PipeTransform {

  transform(value: number, format?: string): string {
    const hours = Math.floor(value / 36e5);
    const mins = Math.floor((value % 36e5) / 6e4);
    const hoursStr = hours < 10 ? "0" + hours : hours;
    const minsStr = mins < 10 ? "0" + mins : mins;
    return hoursStr + ":" + minsStr;
  }

}
